
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.en.md?watch=parent';
    export const toc = [{"id":"dropdown","depth":2,"title":"Dropdown"}];
export const frontmatter = {"title":"Dropdown","toc":"menu","filename":"docs/temp/ui/dropdown.en.md","lastUpdated":1729244528000,"order":4,"redirect_from":["/en/docs","/en/docs/api","/en/docs/api/ui"],"description":"Dropdown menu"};